import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { isLoggedIn } from '@/auth/token';
import ThemeToggle from '@/theme/ThemeToggle';

type Props = {
  children: ReactNode;
};

export default function PublicChrome({ children }: Props) {
  const logged = isLoggedIn();

  return (
    <div className="min-h-screen bg-bg text-textp overflow-y-auto">
      <header className="sticky top-0 z-20 border-b border-border/80 bg-bg/85 backdrop-blur">
        <div className="max-w-5xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-semibold tracking-tight">
            <span className="w-7 h-7 rounded-md bg-accentSoft border border-accentLine flex items-center justify-center">
              <i className="ri-stack-line text-accent" />
            </span>
            Sourcetape
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/marketplace" className="text-sm text-texts hover:text-textp px-2 py-1.5">
              Marketplace
            </Link>
            <Link to="/playbooks" className="text-sm text-texts hover:text-textp px-2 py-1.5">
              Run a playbook
            </Link>
            <Link to="/#showcase" className="text-sm text-texts hover:text-textp px-2 py-1.5">
              Outcomes
            </Link>
            {logged ? (
              <Link to="/dashboard" className="text-sm text-texts hover:text-textp px-2 py-1.5">
                Dashboard
              </Link>
            ) : (
              <Link to="/login" className="text-sm text-texts hover:text-textp px-2 py-1.5">
                Sign in
              </Link>
            )}
            <ThemeToggle className="px-2 py-1.5" />
            <Link
              to="/"
              className="text-sm font-medium bg-accent hover:bg-accent-hover text-accent-text px-3 py-1.5 rounded-md"
            >
              Get started
            </Link>
          </div>
        </div>
      </header>
      {children}
      <footer className="border-t border-border">
        <div className="max-w-5xl mx-auto px-5 py-8 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-sm text-texts">
          <span>Sourcetape · sourcetape.io</span>
          <div className="flex flex-wrap gap-4">
            <Link to="/marketplace" className="hover:text-textp">
              Marketplace
            </Link>
            <Link to="/" className="hover:text-textp">
              Home
            </Link>
            <Link to="/studio" className="hover:text-textp">
              Studio
            </Link>
            <Link to="/privacy" className="hover:text-textp">
              Privacy
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
